import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["parentIdField", "replyBanner", "replySnippet", "textarea"]

  reply(event) {
    const btn = event.currentTarget
    const activityId = btn.dataset.activityId
    const snippet = btn.dataset.snippet

    this.parentIdFieldTarget.value = activityId
    this.replySnippetTarget.textContent = snippet
    this.replyBannerTarget.classList.remove("hidden")
    this.textareaTarget.focus()
  }

  cancelReply() {
    this.parentIdFieldTarget.value = ""
    this.replyBannerTarget.classList.add("hidden")
    this.replySnippetTarget.textContent = ""
  }
}
